export default __webpack_public_path__ + "static/media/twitter.f71afb56.svg";